// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "3524d157650a5065","191": "2230ba6aecba26c4","396": "015c0ffb91aea35e","460": "f0675e9dc5d0af69","498": "80af49f9a43bfbf9","917": "f0fc40fe93d11f9b","985": "4148f38651499ae8",}[chunkId] + ".chunk.js"
}